// removed by extract-text-webpack-plugin
module.exports = {"root":"app--root--31zC-XM8","container":"app--container--_owhRkTM"};


//////////////////
// WEBPACK FOOTER
// ./views/app/styles.css
// module id = ./views/app/styles.css
// module chunks = 0